import { questionMapper } from 'container/questionMapper';
import { compareGroupMapper } from 'container/compareGroupMapper';
import { optionMapper } from 'container/optionMapper';

import { InsightMapper } from '../mapper/InsightMapper';

export const insightMapper = new InsightMapper(questionMapper, compareGroupMapper, optionMapper);
